import styled from '@mui/system/styled'

export const Wrapper = styled('div')(() => ({}))
